import { useCartContext } from "./CartContext";

/** Hook "public" — tu peux le garder comme point d'entrée unique */
export default function useCart() {
  // Tu peux enrichir ici si tu veux (totaux, fallback, etc.)
  return useCartContext();
}
